import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';

const Navigation = () => {
  const { currentUser, logout } = useAuth();
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const handleLogout = () => {
    logout();
    setExpanded(false); // Close menu after logout
  };

  const handleNavClick = () => {
    // Close mobile menu when any nav item is clicked
    setExpanded(false);
  };

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" expanded={expanded}>
      <Container>
        <LinkContainer to="/" onClick={handleNavClick}>
          <Navbar.Brand>MyWebsite</Navbar.Brand>
        </LinkContainer>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={handleToggle}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/" onClick={handleNavClick}>
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/blog" onClick={handleNavClick}>
              <Nav.Link>Blog</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/contact" onClick={handleNavClick}>
              <Nav.Link>Contact</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/files" onClick={handleNavClick}>
              <Nav.Link>Files</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/best-deals" onClick={handleNavClick}>
              <Nav.Link>Best Deals</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/updates" onClick={handleNavClick}>
              <Nav.Link>Updates</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/onestop" onClick={handleNavClick}>
              <Nav.Link>OneStop</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/surveys" onClick={handleNavClick}>
              <Nav.Link>Surveys</Nav.Link>
            </LinkContainer>
            {currentUser && (
              <>
                <LinkContainer to="/dashboard" onClick={handleNavClick}>
                  <Nav.Link>Dashboard</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/profile" onClick={handleNavClick}>
                  <Nav.Link>Profile</Nav.Link>
                </LinkContainer>
                {currentUser.roles && currentUser.roles.some(role => role === 'ROLE_ADMIN') && (
                  <LinkContainer to="/admin" onClick={handleNavClick}>
                    <Nav.Link>Admin</Nav.Link>
                  </LinkContainer>
                )}
              </>
            )}
          </Nav>
          
          {/* Search Bar */}
          <div className="d-none d-lg-block me-3" style={{ width: '300px' }}>
            <SearchBar placeholder="Search..." />
          </div>
          
          <Nav>
            {currentUser ? (
              <>
                <Navbar.Text className="me-3 d-none d-xl-block">
                  Welcome, {currentUser.username}!
                </Navbar.Text>
                <Button variant="outline-light" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <>
                <LinkContainer to="/login" onClick={handleNavClick}>
                  <Nav.Link>Login</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/register" onClick={handleNavClick}>
                  <Nav.Link>Register</Nav.Link>
                </LinkContainer>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;